import { Component, Injector, OnInit, HostListener, AfterViewInit } from '@angular/core';
import { RacesService } from "../../services/races.service";
import { RaceViewModel } from "../races/Model/RaceViewModel";
import { RaceDialogBaseComponent } from "./race-dialog/race-dialog-base.component"
import { BaseComponentWithDialog } from "../admin-panel/base-admin-panel/base-component-with-dialog";

@Component({
    selector: 'app-races',
    templateUrl: './races.component.html',
    styleUrls: ['races.component.css'],
    standalone: false
})
export class RacesComponent extends BaseComponentWithDialog implements OnInit,AfterViewInit
{
  private racesService: RacesService;
  public objects: RaceViewModel[] = [];

  private fromInterval: number = 0;
  private tillInterval: number = 0;

  constructor(protected injector: Injector)
  {
      super(injector);
      this.racesService = injector.get(RacesService);
  }

  @HostListener('window:TimeInterval', ['$event'])
  onFilterApply(evt)
  {
    if (evt.detail && evt.detail.from)
    {
      this.fromInterval = evt.detail.from;
      this.tillInterval = evt.detail.till;
    }

    this.onActivityChange();
  }
  @HostListener('window:EntitieChange', ['$event'])
  onActivityChange()
  {
    if (this.fromInterval && this.tillInterval)
      this.racesService.get(this.fromInterval, this.tillInterval).subscribe(arr => { this.objects = arr; });
  }

  ngOnInit()
  {
  }

  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "Races" }));
  }
  public openCreateModal() {
    this.prepareModal(RaceDialogBaseComponent);
    this.componentRef.instance.open(new RaceViewModel());
  }
}
